const firebaseConfig = {
  apiKey: "AIzaSyAdZof-QG49w3YxQ4ROtKHY2k867z23a60",
  authDomain: "wellness-shop.firebaseapp.com",
  projectId: "wellness-shop",
  storageBucket: "wellness-shop.appspot.com",
  messagingSenderId: "529920173318",
  appId: "1:529920173318:web:abfc18453779da1a722a87"
};
export default firebaseConfig;
